/**
 * AccessibilityFloatingButton — small persistent button anchored to the
 * bottom-left of every authenticated page. Opens the accessibility settings
 * panel. Hidden on the public landing/marketing pages so we don't crowd them.
 */
import { useState } from "react";
import { Accessibility } from "lucide-react";
import AccessibilitySettingsPanel from "@/components/accessibility/AccessibilitySettingsPanel";

export default function AccessibilityFloatingButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Open accessibility settings"
        title="Accessibility settings"
        data-testid="a11y-floating-btn"
        className="fixed bottom-4 left-4 z-[150] w-12 h-12 rounded-full bg-purple-700 hover:bg-purple-800 text-white shadow-lg flex items-center justify-center focus:outline-none focus:ring-4 focus:ring-purple-300"
      >
        <Accessibility className="w-6 h-6" aria-hidden="true" />
      </button>
      <AccessibilitySettingsPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
